<div class="answer-points">
    <stars :percent="percent" />
</div>
